import AttachmentAPI from '../../api/attachments';

const state = {
  selectedRows: [],
  loading: false,
  meta: {},
  sortConfig: {
    byte_size: 'desc',
  },
  attachments: [],
};

export const getters = {
  getSelectedRows($state) {
    return $state.selectedRows;
  },
  getLoading($state) {
    return $state.loading;
  },
  getMeta($state) {
    return $state.meta;
  },
  getAttachments($state) {
    return $state.attachments;
  },
  getSortConfig($state) {
    return $state.sortConfig;
  },
  getSortAttribute($state) {
    return Object.keys($state.sortConfig).reduce((acc, sortKey) => {
      const sortOrder = $state.sortConfig[sortKey];
      if (sortOrder) {
        const sortOrderSign = sortOrder === 'asc' ? '' : '-';
        return `${sortOrderSign}${sortKey}`;
      }
      return acc;
    }, '');
  },
};

export const actions = {
  async fetchRecords({ commit, getters: { getSortAttribute } }, { page } = {}) {
    commit('SET_LOADING', true);
    try {
      const {
        data: { attachments, meta },
      } = await AttachmentAPI.get({
        page: page || 1,
        sort: getSortAttribute,
      });
      commit('SET_RESPONSE', {
        attachments,
        meta,
      });
    } catch (e) {
      console.log(e);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async deleteAttachments({ state: { selectedRows }, commit, dispatch }) {
    if (!selectedRows.length) return;

    await AttachmentAPI.batchDestroy(selectedRows);
    commit('SET_SELECTED_ROWS', []);
    dispatch('fetchRecords');
  },
};

export const mutations = {
  SET_SELECTED_ROWS($state, data) {
    $state.selectedRows = data;
  },
  SET_RESPONSE($state, { meta, attachments }) {
    $state.meta = meta;
    $state.attachments = attachments;
  },
  SET_SORT_CONFIG($state, value) {
    $state.sortConfig = value;
  },
  SET_LOADING($state, value) {
    $state.loading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
